<div [formGroup]="formModel.formGroup()">
  <h3 class="my-5px mt-10px">{{ "updateEmail.header" | translate }}</h3>
  <h4 class="color-gray f-w-normal my-5px">{{ "updateEmail.subheader" | translate }}</h4>
  <div class="input-group mt-20px">
    <label>{{ "email" | translate }}</label>
    <sxw-text-input formControlName="email" placeHolder="placeholder.newEmail"></sxw-text-input>
  </div>
</div>
